/**
 * Eigenbau: Kette benannter Schritte — ausdrücklich nicht Tremors Tracker.
 *
 * Ein Punkt je Schritt: gefüllt heißt gelaufen, Ring heißt läuft, leer heißt
 * ausstehend, durchgestrichen heißt übersprungen. Paket 19 schließt den
 * naheliegenden Baustein aus dem Bestand selbst aus:
 *
 * > Nicht der `Tracker` — der ist für gleichartige Läufe über Zeit, nicht für
 * > eine Folge benannter Schritte.
 *
 * Der Unterschied ist nicht kosmetisch: Beim `Tracker` sind alle Felder
 * dasselbe Ereignis zu verschiedenen Zeiten, hier ist jedes Feld ein anderes
 * Rezept. Deshalb trägt jeder Punkt einen eigenen Namen und ein eigenes
 * Ergebnis.
 *
 * ── Barrierefreiheit ──────────────────────────────────────────────────────
 *
 * Die Anzeige ist dekorativ (`aria-hidden`), wie Paket 19 verlangt: „Die
 * Kettenanzeige ist dekorativ; der Zustand steht als Text daneben. Sie darf
 * nicht die einzige Quelle sein." Der Fortschritt gehört deshalb als Satz in
 * die Zeile — „Schritt 2 von 4 · Sicherheitsprüfung" —, nicht in diese Punkte.
 */

import { cx } from "@/lib/utils";
import { STAND, type Stand } from "@/lib/entwurf-zustaende";

export type Kettenglied = {
  /** Rezeptname, für den Tooltip. */
  name: string;
  stand: Stand;
  /** Ergebnis im Klartext, für den Tooltip. */
  ergebnis?: string;
};

export function Kettenanzeige({
  glieder,
  className,
}: {
  glieder: readonly Kettenglied[];
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cx("flex flex-none items-center gap-[5px]", className)}
    >
      {glieder.map((glied, i) => {
        const bild = STAND[glied.stand];
        return (
          <span
            key={i}
            // Der Titel je Punkt ist der einzige Weg, an Rezeptname und
            // Ergebnis zu kommen, ohne die Zeile zu verlängern. Er ersetzt
            // nicht den Text daneben — er ergänzt ihn für die Maus.
            title={
              glied.ergebnis
                ? `${glied.name} — ${glied.ergebnis}`
                : `${glied.name} — ${bild.label}`
            }
            className={cx(
              "relative block size-[7px] border",
              bild.fuellung,
              bild.rand,
            )}
          >
            {bild.strich ? (
              <span className="absolute left-0 top-1/2 h-px w-full -translate-y-1/2 bg-ring" />
            ) : null}
          </span>
        );
      })}
    </span>
  );
}
